exports = module.exports = require("../../../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mod-component-tips {\n  position: absolute;\n  z-index: 999;\n  top: 25%;\n  width: 200px;\n  left: 0;\n  right: 0;\n  margin: auto;\n  background-color: rgba(103, 111, 108, 0.9);\n  border-radius: 5px; }\n  .mod-component-tips div {\n    text-align: center;\n    padding-top: 15px;\n    color: white;\n    font-size: 44px; }\n  .mod-component-tips p {\n    font-size: 14px;\n    padding: 10px;\n    margin: 0 10px;\n    color: #fff;\n    text-align: center;\n    line-height: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.25.0@css-loader?{}!./node_modules/_sass-loader@4.0.2@sass-loader?{"sourceMap":true}!./node_modules/_postcss-loader@1.3.3@postcss-loader?{"sourceMap":true}!./src/component/view/footer/tip/style.scss
// module id = 169
// module chunks = 0 1